/**
 * @file The one-shot read of `attachments/{fileUid}`, the document that holds
 * an attachment's whole version history. Consumers: `useAttachmentDownload`,
 * which needs a version's bytes, and `useAttachmentVersionHistory`, which needs
 * the saves the artifact document does not keep.
 *
 * The read never throws: a missing document and a denied read both come back as
 * null, because both callers degrade rather than fail. The rules allow any
 * authenticated user to read here, so a denial means the session, not the file.
 */
import { doc, getDoc } from 'firebase/firestore';

import { Attachment } from '#types/System.types';
import { firestore } from './startFirestore';

export const readAttachmentDocument = async (fileUid: string): Promise<Attachment | null> => {
  try {
    const snapshot = await getDoc(doc(firestore, 'attachments', fileUid));
    return snapshot.exists() ? (snapshot.data() as Attachment) : null;
  } catch (error) {
    console.error(`Failed to fetch metadata for file ${fileUid}:`, error);
    return null;
  }
};
